export default function fileExtensionToOfficeFileType(fileExtension: string): string {
    switch (fileExtension) {
        case 'csv':
        case 'ods':
        case 'xls':
        case 'xlsb':
        case 'xlsm':
        case 'xlsx':
            return 'Excel';
        case 'odp':
        case 'pot':
        case 'potm':
        case 'potx':
        case 'pps':
        case 'ppsm':
        case 'ppsx':
        case 'ppt':
        case 'pptm':
        case 'pptx':
            return 'PowerPoint';
        case 'vsd':
        case 'vsdm':
        case 'vsdx':
            return 'Visio';
        case 'doc':
        case 'docm':
        case 'docx':
        case 'dot':
        case 'dotm':
        case 'dotx':
        case 'odt':
        case 'rtf':
            return 'Word';
        default:
            return '';
    }
}
